import User from './user';
import Form from './form';
import {combineReducers} from 'redux';

export default combineReducers({
    User,
    Form
});